var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharacterSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 338 621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "legs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 25",
    d: "M54.0009 605.939C54.0005 597.942 58.4928 591.397 64.1744 590.879H133.214C138.896 591.397 143.389 597.942 143.389 605.939C143.39 613.937 138.898 620.482 133.216 621H64.1761C58.4944 620.482 54.0014 613.937 54.0009 605.939Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 26",
    d: "M188.857 605.813C188.857 597.747 193.387 591.147 199.116 590.625H268.74C274.469 591.147 279 597.747 279.001 605.813C279.001 613.878 274.471 620.478 268.741 621.001H199.118C193.388 620.478 188.857 613.878 188.857 605.813Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 49",
    x: 74.0001,
    y: 446,
    width: 181,
    height: 52,
    fill: "#5D72A8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 50",
    x: 74.0001,
    y: 483,
    width: 67,
    height: 102,
    rx: 5,
    fill: "#5D72A8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 45",
    x: 188,
    y: 483,
    width: 67,
    height: 102,
    rx: 5,
    fill: "#5D72A8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upper-body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bust"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 134",
    d: "M255 446L75.0001 446L75.0001 287.134L107.553 262.375L221.079 261L255 287.134L255 446Z",
    fill: "#DEE3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39",
    x: 74.0001,
    y: 349,
    width: 180,
    height: 20,
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 46",
    x: 74.0001,
    y: 388,
    width: 180,
    height: 20,
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 47",
    x: 75.0001,
    y: 427,
    width: 180,
    height: 19,
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 48",
    d: "M75.0001 311H254V331H75.0001V311Z",
    fill: "#0B1345"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 135",
    d: "M273.657 160.188C298.957 163.578 302.752 195.354 270.283 202.981L273.657 160.188Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 136",
    d: "M11.0536 186.819L35.3403 143.877H63.6012C71.844 163.091 85.5035 206.317 74.1991 225.506C62.8947 244.694 58.0079 229.632 56.9776 219.703C39.6678 223.726 35.3403 213.126 35.3403 207.323C10.9653 215.37 8.9929 197.006 11.0536 186.819Z",
    fill: "#440919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 137",
    d: "M58.2577 160.188C32.9571 163.578 29.162 195.354 61.6311 202.981L58.2577 160.188Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 138",
    d: "M170.611 61.543C60.1316 61.543 49.3086 144.586 60.1316 186.108C60.1316 251.066 86.6145 283.556 170.611 283.556C243.99 283.556 273.079 257.669 273.079 186.108C284.042 158.144 273.079 61.543 170.611 61.543Z",
    fill: "#FEC7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 22",
    d: "M189.909 226.281C189.909 223.356 187.536 220.963 184.534 220.773C171.812 226.258 164.412 228.37 148.057 220.773C145.055 220.963 142.682 223.356 142.682 226.281C142.682 229.206 145.055 231.6 148.057 231.789C165.981 241.931 172.473 237.81 184.534 231.789C187.536 231.6 189.909 229.206 189.909 226.281Z",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 131",
    d: "M167.11 164.849C148.551 197.945 156.044 198.784 167.11 202.557C178.074 199.167 185.243 196.625 167.11 164.849Z",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 132",
    d: "M127.604 32.4253C81.3778 31.2565 60.3791 81.1608 8.51917 136.242C5.45236 139.499 7.76791 145.061 12.239 145.254C46.7646 146.74 62.7363 154.259 130.047 123.341C164.329 107.594 189.889 93.9864 189.371 74.7144C188.412 39.0688 152.709 33.0602 127.604 32.4253Z",
    fill: "#440919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 133",
    d: "M251.336 48.3387C222.336 15.3274 157.915 35.9106 163.175 65.4267C173.835 125.235 243.474 144.783 276.47 160.577C285.44 161.82 290.519 169.121 291.937 172.616C297.814 192.811 281.239 200.449 272.216 201.744C274.072 205.472 269.123 225.564 266.416 235.143C283.12 236.076 285.234 220.774 286.523 213.395C306.321 222.716 310.239 209.511 309.723 201.744C343.132 208.268 340.142 180.125 334.47 165.237C333.31 160.965 297.844 101.28 251.336 48.3387Z",
    fill: "#440919"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 23",
    cx: 19.7354,
    cy: 29.1673,
    rx: 19.7354,
    ry: 29.1673,
    transform: "matrix(0.907456 -0.420146 0.417123 0.90885 63.4741 184.513)",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 24",
    cx: 19.7372,
    cy: 29.1647,
    rx: 19.7372,
    ry: 29.1647,
    transform: "matrix(-0.896268 -0.443513 -0.440399 0.897802 271.03 185.463)",
    fill: "#F26D5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 127",
    d: "M247.941 181.286H193.123C187.219 144.001 196.56 133.686 215.05 132.138C245.411 129.595 258.225 162.876 247.941 181.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pupil"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-1_439_210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.385 162.728C194.407 167.195 198.235 177.151 200.272 181.571H228.371C234.235 170.963 233.045 159.239 228.371 153.656C217.62 140.815 205.158 146.798 200.272 152.149C223.327 164.013 213.554 167.502 195.385 162.728Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.385 162.728C194.407 167.195 198.235 177.151 200.272 181.571H228.371C234.235 170.963 233.045 159.239 228.371 153.656C217.62 140.815 205.158 146.798 200.272 152.149C223.327 164.013 213.554 167.502 195.385 162.728Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-22-inside-1_439_210)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eye-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 129",
    d: "M83.4979 181.286H138.316C144.219 144.001 134.878 133.686 116.389 132.138C86.028 129.595 73.2139 162.876 83.4979 181.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pupil"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-2_439_210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7168 162.728C97.7394 167.195 101.567 177.151 103.604 181.571H131.703C137.567 170.963 136.377 159.239 131.703 153.656C120.952 140.815 108.491 146.798 103.604 152.149C126.659 164.013 116.886 167.502 98.7168 162.728Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.7168 162.728C97.7394 167.195 101.567 177.151 103.604 181.571H131.703C137.567 170.963 136.377 159.239 131.703 153.656C120.952 140.815 108.491 146.798 103.604 152.149C126.659 164.013 116.886 167.502 98.7168 162.728Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-24-inside-2_439_210)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "arms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arm-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 41",
    d: "M23 335.807C23 309.404 44.4038 288 70.8066 288C73.4469 288 75.5873 290.14 75.5873 292.781V418.929C75.5873 421.69 73.3487 423.929 70.5873 423.929H28C25.2386 423.929 23 421.69 23 418.929V335.807Z",
    fill: "#DEE3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 42",
    x: 23,
    y: 330.721,
    width: 52.5873,
    height: 19.4184,
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 43",
    x: 23,
    y: 368.78,
    width: 52.5873,
    height: 19.4184,
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 44",
    d: "M23 407.617H75.5873V418.929C75.5873 421.69 73.3487 423.929 70.5873 423.929H28C25.2386 423.929 23 421.69 23 418.929V407.617Z",
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "hand-1",
    cx: 50.8401,
    cy: 449.561,
    rx: 21.6536,
    ry: 21.7486,
    fill: "#FEC7A9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arm-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40",
    d: "M306.587 335.807C306.587 309.404 285.184 288 258.781 288C256.14 288 254 290.14 254 292.781V418.929C254 421.69 256.239 423.929 259 423.929H301.587C304.349 423.929 306.587 421.69 306.587 418.929V335.807Z",
    fill: "#DEE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 51",
    d: "M254 408H306V419C306 421.761 303.761 424 301 424H259C256.239 424 254 421.761 254 419V408Z",
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 52",
    x: 254,
    y: 331,
    width: 52,
    height: 19,
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 53",
    x: 254,
    y: 369,
    width: 52,
    height: 19,
    fill: "#0B1345"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "hand-2",
    cx: 279.52,
    cy: 449.561,
    rx: 21.6536,
    ry: 21.7486,
    fill: "#FEC7A9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterSimple);
export default __webpack_public_path__ + "static/media/character-simple.0489022e29d1edfcf8296b86194b7bd7.svg";
export { ForwardRef as ReactComponent };